import { SubscriptionTier, SubscriptionType } from "../../../types";
import AutoRenewTooltip from "../../AutoRenewTooltip/AutoRenewTooltip";

export const SubscriptionExpirationText: React.FC<{
  autoRenews: boolean;
  subscriptionType: SubscriptionType;
  expirationDate: Date;
  hasAppStoreSubscription?: boolean;
  subscriptionTier: SubscriptionTier;
}> = ({
  autoRenews,
  subscriptionType,
  expirationDate,
  hasAppStoreSubscription,
  subscriptionTier,
}) => {
  if (subscriptionType === SubscriptionType.Paddle && hasAppStoreSubscription) {
    return <>Starts on</>;
  }

  if (autoRenews) {
    return (
      <>
        <span>Auto-renews on </span>
        <AutoRenewTooltip
          isAutoRenewEnabled={autoRenews}
          expirationDate={expirationDate}
          type={subscriptionType}
          subscriptionTier={subscriptionTier}
        />
      </>
    );
  }

  return <>Expires on</>;
};
